import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash/fp';
import { selectEntityId } from 'app/store/entities/selectors.js';
import type { RootState } from 'app/store/reducers';

const selectSlice = (state: RootState) => state.columnWidths;
const selectPropEntityId = (_: RootState, props: { entityId: string }) => props.entityId;

const selectDatasetColumnWidths = createSelector(selectSlice, get('dataGridPanel'));
const selectExplorerColumnWidths = createSelector(selectSlice, get('explorerDataGrid'));
const selectMetadataColumnWidths = createSelector(selectSlice, get('columnMetadataGrid'));
const selectDataProfileColumnsWidth = createSelector(selectSlice, get('dataProfile'));

export const selectDatasetColumnWidthsForEntityId = createSelector(
    [selectDatasetColumnWidths, selectPropEntityId],
    (datasetColumnWidths, entityId) => (datasetColumnWidths ? datasetColumnWidths[entityId] : null)
);

export const selectExplorerColumnWidthsForEntityId = createSelector(
    [selectExplorerColumnWidths, selectEntityId],
    (explorerColumnWidths, entityId) =>
        explorerColumnWidths ? explorerColumnWidths[entityId] : null
);

export const selectMetadataGridColumnWidthsForEntityId = createSelector(
    [selectMetadataColumnWidths, selectPropEntityId],
    (metadataColumnWidths, entityId) =>
        metadataColumnWidths ? metadataColumnWidths[entityId] : null
);

export const selectDataProfileColumnWidthForEntityId = createSelector(
    [selectDataProfileColumnsWidth, selectPropEntityId],
    (dataProfileColumnsWidth, entityId) =>
        dataProfileColumnsWidth ? dataProfileColumnsWidth[entityId] : null
);
